export default "__VITE_ASSET__Bm1RaKs3__"